<div class="modal fade show d-block custom-modal-backdrop" tabindex="-1" role="dialog" aria-labelledby="buyLicenseModal"
  aria-modal="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">

      <!-- Header -->
      <div class="modal-header bg-gradient text-white">
        <h5 class="modal-title fw-bold">
          <i class="bi bi-shield-lock-fill me-2"></i> Licencia requerida
        </h5>
      </div>

      <!-- Body -->
      <div class="modal-body text-center py-5">
        <div class="icon-container mx-auto mb-4">
          <i class="bi bi-exclamation-triangle text-warning display-4"></i>
        </div>

        <h4 class="fw-bold text-primary">Acceso restringido</h4>
        <p class="text-muted mt-2 px-3">
           Módulo  en desarrollo
        </p>

        <div class="mt-4">
          <button class="btn btn-outline-secondary btn-lg px-4" (click)="closeModal()">
            <i class="bi bi-x-circle me-1"></i> Cerrar
          </button>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer bg-light small text-muted justify-content-center text-center">
        © {{ currentYear }} Sistema de Información y Administración de Cálculos — SIACI
        <span class="d-block text-muted">Módulos en desarrollo</span>
      </div>
    </div>
  </div>
</div>